<template>
    <div>
        <!-- Add the modal dialog
        <v-dialog
            v-model="showModal"
            persistent
            max-width="700"
        >
            <v-card>
                <v-card-title class="headline red white--text">
                    COMUNICAZIONE IMPORTANTE
                </v-card-title>
                <v-card-text class="pt-4">
                    <p>Le emissioni contrattuali della compagnia Verti potranno essere effettuate entro il giorno 24 maggio 2025 e su clienti la cui scadenza di copertura in ANIA sia entro il 25 maggio.</p>
                    <p>Non sono ammesse emissioni con data di decorrenza o coperture superiori al giorno 25 maggio 2025.</p>
                    <p>Per tutte le emissioni con data di decorrenza delle garanzie successive al 25 maggio l'offerta che dovrà essere presa in considerazione in prima battuta è quella di ITAS, evidenziata su TEO.</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="showModal = false"
                    >
                        Ho capito
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
 <!-- <v-card>
                <v-card-title class="headline red white--text">
                    COMUNICAZIONE IMPORTANTE
                </v-card-title>
                <v-card-text class="pt-4">
                    <p>Le emissioni contrattuali della compagnia Verti potranno essere effettuate entro il giorno 24 maggio 2025 e su clienti la cui scadenza di copertura in ANIA sia entro il 25 maggio.</p>
                    <p>Non sono ammesse emissioni con data di decorrenza o coperture superiori al giorno 25 maggio 2025.</p>
                    <p>Per tutte le emissioni con data di decorrenza delle garanzie successive al 25 maggio l'offerta che dovrà essere presa in considerazione in prima battuta è quella di ITAS, evidenziata su TEO.</p>
                </v-card-text>
     
            </v-card> -->
  <v-card>

          <!-- <img src="autoretro.png" alt="Logo"> -->

          
            <v-card-title>
               
                        Documenti Per Autostoriche ITAS
           
            </v-card-title>
            <v-card-text>
                <v-list>
                    <v-list-item v-for="(item, index) in auto_storica_itas.downloads" :key="index">
                        <v-list-item-avatar>
                            <v-icon>mdi-file-pdf-box</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                <a :href="item.link" download target="_blank">{{
                                    item.name
                                }}</a>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            




        </v-card>



        <v-card>

          <!-- <img src="autoretro.png" alt="Logo"> -->

          
            <v-card-title>
                      Documenti Per Autostoriche GOOld
            </v-card-title>
            <v-card-text>
                <v-list>
                    <v-list-item v-for="(item, index) in auto_storica_verti_goold.downloads" :key="index">
                        <v-list-item-avatar>
                            <v-icon>mdi-file-pdf-box</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                <a :href="item.link" download target="_blank">{{
                                    item.name
                                }}</a>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            


    <v-card-title>Precontrattuale</v-card-title>
    <v-card-text>
      *Il cliente dichiara di aver consultato e preso visione dei moduli:
      <a target="_blank" :href="VUE_APP_API_URL + '/docs/1 -Allegato 3  4 - 4ter STORICHE 4-23.pdf'" >Allegato 3/4/4 Ter.</a>,
      <!-- <a :href="VUE_APP_API_URL + '/docs/allegato_4.pdf'">Allegato 4</a>,
      <a :href="VUE_APP_API_URL + '/docs/allegato_4_ter.pdf'">Allegato 4 TER</a>, -->
      <a
        :href="
          VUE_APP_API_URL + '/docs/informativa_precontrattuale_contratti_distanza.pdf'
        "
      >
        Informativa precontrattuale relative ai contratti stipulati a distanza </a
      >,
      <a :href="VUE_APP_API_URL + '/docs/lettera_incarico_broker.pdf'"
        >Lettera incarico Broker</a
      >,
      <a
        :href="VUE_APP_API_URL + '/docs/set_informativo_verti_veicoli_storici.pdf'"
        @click.stop
        target="_blank"
      >
        Set informativo VERTI Assicurazioni SpA </a
      >,
      <a
        :href="VUE_APP_API_URL + '/docs/set_informativo_am_trust_privacy.pdf'"
        @click.stop
        target="_blank"
      >
        Set informativo AmTrust Assicurazioni SpA </a
      >,
      <a
        :href="VUE_APP_API_URL + '/docs/informativa_infodrive_spa.pdf'"
        @click.stop
        target="_blank"
      >
        Informativa Infodrive SpA
      </a>
    </v-card-text>


<v-card-text>
    <v-card-title>Modalità di invio documentazione</v-card-title>

<v-card-text>
      La formula assicurativa proposta prevede l’invio della documentazione in modalità
      telematica, quindi senza invio di tutta la documentazione in modalità cartacea. Il
      cliente dichiara di aver consultato e preso visione del modulo:
      <a
        :href="
          VUE_APP_API_URL +
          '/docs/a8_3b_otp_informativa_generale_trattamento_dei_dati_aurum.docx'
        "
      >
        Informativa al cliente per l’erogazione del servizio di firma elettronica avanzata
        tramite OTP </a
      >,
      <a
        :href="
          VUE_APP_API_URL +
          '/docs/A7_3a_-OTP-Condizioni_Generali_del_Servizio_-_Aurum.docx'
        "
      >
        Condizioni generali di servizio per l’utilizzazione della soluzione di firma
        elettronica avanzata
      </a>
    </v-card-text>
</v-card-text>
        </v-card>

        <!-- <a :href="VUE_APP_API_URL+'/docs/set_informativo_verti_veicoli_storici.pdf'" @click.stop
                                                target="_blank">Set
                                                informativo VERTI Assicurazioni SpA</a>,
                                            <a :href="VUE_APP_API_URL+'/docs/set_informativo_am_trust_privacy.pdf'" @click.stop
                                                target="_blank">Set informativo AmTrust Assicurazioni SpA</a>,
                                            <a :href="VUE_APP_API_URL+'/docs/informativa_infodrive_spa.pdf'" @click.stop
                                                target="_blank">Informativa Infodrive
                                                SpA</a>                                        -->
    </div>
</template>

<script>
import { EnvMixin } from "@/mixin/EnvMixin";
export default {
    mixins: [EnvMixin],
    data: () => ({
        drawer: null,
        showModal: true, // Add this to control the modal visibility
        auto_storica_verti_goold:{
                downloads: [
            {
                name: "Set Informativo AM Trust Privacy",
                link:
                    process.env.VUE_APP_API_URL +
                    "/docs/set_informativo_am_trust_privacy.pdf",
            },
            {
                name: "Set Informativo Verti Veicoli Storici",
                link:
                    process.env.VUE_APP_API_URL +
                    "/docs/set_informativo_verti_veicoli_storici.pdf",
            },
            {
                name: "Set Informativa infodrive spa",
                link:
                    process.env.VUE_APP_API_URL +
                    "/docs/informativa_infodrive_spa.pdf",
            },
            {
                name: "Privacy Aurum dal Febbraio 2023",
                link:
                    process.env.VUE_APP_API_URL +
                    "/docs/privacy-AURUM-dal-2-2023.pdf",
            },
        ],
        },


        auto_storica_itas:{
      downloads: [
            {
                name: "Condizioni di assicurazione POLIZZA R.C.A. / C.V.T. – ASSISTORICA",
                link:
                    process.env.VUE_APP_API_URL +
                    "/docs/itas/CGA ITAS.pdf",
            },
            {
                name: "Documento informativo relativo al prodotto assicurativo",
                link:
                    process.env.VUE_APP_API_URL +
                    "/docs/itas/DIP ITAS.pdf",
            }
          ]
        }

    }),
    components: {},
    mounted() {
        this.$store.state.compagnie;
    },
    computed: {
        cards() {
            return this.$store.state.dashboard.cards;
        },
        breadcrumbs() {
            return this.$store.state.breadcrumbs;
        },
    },
};
</script>

<style scoped>
.v-card-text p {
    margin-bottom: 1em;
}
</style>
